import React, { useEffect } from "react";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import Home from "containers/Home/Home";
import Footer from "components/Footer/footer";
import { useDispatch } from "react-redux";
import ProgramDetails from "components/ProgramDetails/programDetails";
import NavBar from "components/NavBar/navbar";
import SiteAnnouncementBanner from "components/SiteAnnouncement/SiteAnnouncementBanner";
import useContentful from "hooks/useContentful";
import { setSelectedProgram } from "store/actions/navigationActions";
import Staff from "containers/Staff/Staff";
import Events from "components/Events/events";
import CareerPage from "components/CareerPage/careerPage";
import JobApplication from "components/JobApplication/jobApplication";
import Meet from "components/MeetPage/meet";
import MeetInfo from "components/MeetPage/components/MeetInfo/meetInfo";
import Contact from "containers/Contact/Contact";
import Privacy from "containers/Privacy/Privacy";
import Calendar from "containers/Calendar/Calendar";
import NotFound from "containers/NotFound/NotFound";
import OwnerDashboard from "containers/OwnerDashboard/OwnerDashboard";
import RouteAnalytics from "components/Analytics/RouteAnalytics";
import { ENROLLMENT_DASHBOARD_ENABLED, MEET_PAGE_ENABLED } from "config/featureFlags";

const App = () => {
  const {
    getContentfulStaff,
    getContentfulPrograms,
    getContentfulEvents,
    getContentfulCareers,
    getContentfulJob,
    getContentfulCalendar,
    getContentfulSiteAnnouncement,
    getContentfulMeetCards,
    getContentfulGymnasticMeets,
  } = useContentful();
  const dispatch = useDispatch();

  useEffect(() => {
    getContentfulStaff();
    getContentfulPrograms();
    getContentfulEvents();
    getContentfulCareers();
    getContentfulJob();
    getContentfulCalendar();
    getContentfulSiteAnnouncement();
    if (MEET_PAGE_ENABLED) {
      getContentfulMeetCards();
      getContentfulGymnasticMeets();
    }
    return () => {
      dispatch(setSelectedProgram(""));
    };
  }, [
    dispatch,
    getContentfulPrograms,
    getContentfulStaff,
    getContentfulEvents,
    getContentfulCareers,
    getContentfulJob,
    getContentfulCalendar,
    getContentfulSiteAnnouncement,
    getContentfulMeetCards,
    getContentfulGymnasticMeets,
  ]);

  return (
    <>
      <div className="App app-layout">
        <RouteAnalytics />
        <NavBar />
        <SiteAnnouncementBanner />
        <main className="app-main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/programs/program-details/*" element={<ProgramDetails />} />
            <Route path="/staff" element={<Staff />} />
            <Route path="/events" element={<Events />} />
            <Route path="/employment" element={<CareerPage />} />
            <Route path="/job-application" element={<JobApplication />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/calendar" element={<Calendar />} />
            {ENROLLMENT_DASHBOARD_ENABLED && (
              <Route path="/owner/dashboard" element={<OwnerDashboard />} />
            )}
            {MEET_PAGE_ENABLED && (
              <>
                <Route path="/bourbon-city-spectacular" element={<Meet />} />
                <Route path="/meet-info/:meetId" element={<MeetInfo />} />
              </>
            )}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        {/* <AnalyticsConsent /> */}
      </div>
    </>
  );
};

export default App;
